<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div>
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" />
        </div>

        <div class="mb-5">
          <div class="label-input">Layout</div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <label>Background Section</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['card-container']"
                    @change="event => (fields['card-container'] = event.target.value)"
                  />
                  <v-text-field v-model="fields['card-container']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <label>Text Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['text-color']"
                    @change="event => (fields['text-color'] = event.target.value)"
                  />
                  <v-text-field v-model="fields['text-color']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <label>Slides per view (Desktop)</label>
                <v-text-field
                  type="number"
                  min="1"
                  v-model.number="fields['col-per-view']"
                  :hide-details="true"
                  class="mt-0"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-checkbox
                  v-model="fields['top-padding']"
                  label="Padding top"
                  :hide-details="true"
                  class="mb-2 mt-0"
                />
                <v-checkbox
                  v-model="fields['bottom-padding']"
                  label="Padding bottom"
                  :hide-details="true"
                  class="mb-2 mt-0"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-5">
          <div class="label-input">Container</div>
          <div class="group-item">
            <v-row class="mb-0">
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="fields['container-page']['show-style']"
                  label="Show Style Container"
                  :hide-details="true"
                  class="mt-0"
                />
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['container-page']['background']"
                    @change="event => (fields['container-page']['background'] = event.target.value)"
                  />
                  <v-text-field v-model="fields['container-page']['background']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-5">
          <div class="label-input">Title Card</div>
          <div class="group-item">
            <v-checkbox
              v-model="fields['title-card'].show"
              label="Show title card"
              :hide-details="true"
              class="mt-0 mb-2"
            />
            <ckeditor :editor="editor" v-model="fields['title-card'].content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex align-center mb-2">
            <label class="label-input mb-0">Reviews</label>
            <v-spacer />
            <v-btn small text color="primary" @click="handleAddReview">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Review</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields.reviews" :key="i">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center w-100">
                    <span>Review {{ i + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveReview(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <UploadImage
                    @callback="obj => handleUploadImage(obj, i)"
                    :image="{ imageSrc: item.image }"
                    :height="`220`"
                    :typeUpload="'image'"
                    @callbackDelete="() => handleRemoveUpload(i)"
                  />
                  <div class="my-3">
                    <label>Stars</label>
                    <v-rating
                      color="warning"
                      background-color="#c1c1c1"
                      empty-icon="mdi-star-outline"
                      full-icon="mdi-star"
                      hover
                      length="5"
                      size="28"
                      :value="item.stars"
                      @input="value => (item.stars = Number(value))"
                    />
                  </div>
                  <div class="mb-3">
                    <label>Review Content</label>
                    <ckeditor :editor="editor" v-model="item.content" :config="editorConfig" />
                  </div>
                  <div>
                    <label>Reviewer Name</label>
                    <v-text-field v-model="item.name" :hide-details="true" class="mt-0" />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex align-center mb-2">
            <label class="label-input mb-0">Button</label>
            <v-spacer />
            <v-checkbox v-model="fields.button.show" :hide-details="true" class="mt-0" />
          </div>
          <div class="group-item">
            <div>
              <label>Button Text</label>
              <v-text-field v-model="fields.button.text" :hide-details="true" class="mt-0" />
            </div>
            <v-row>
              <v-col cols="12" md="6">
                <label>Button Link</label>
                <v-text-field v-model="fields.button.link" :hide-details="true" class="mt-0" />
              </v-col>
              <v-col cols="12" md="6">
                <label>Button Radius</label>
                <v-text-field type="number" v-model="fields.button.radius" :hide-details="true" class="mt-0" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <label>Button Background</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.button.background"
                    @change="event => (fields.button.background = event.target.value)"
                  />
                  <v-text-field v-model="fields.button.background" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label>Button Text Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.button.color"
                    @change="event => (fields.button.color = event.target.value)"
                  />
                  <v-text-field v-model="fields.button.color" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '../common/form/upload-file/upload-image.vue';
import { updateHtmlFromData } from '../common/html/update';

export default {
  name: 'slider-review-kynorelle-section-editor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Slider Review Kynorelle Section',
        'card-container': '#FFFFFF',
        'text-color': '#003568',
        'top-padding': true,
        'bottom-padding': true,
        'container-page': {
          'show-style': false,
          background: '#FFFFFF',
        },
        'content-title': {
          show: true,
          heading: '',
        },
        'title-card': {
          show: true,
          content: '',
        },
        'col-per-view': 4,
        reviews: [],
        button: {
          show: true,
          text: 'SHOP NOW',
          link: '#',
          background: '#003568',
          color: '#ffffff',
          radius: '4',
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
      'container-page': {
        ...this.fields['container-page'],
        ...(this.sectionEditor.sectionExtract['container-page'] || {}),
      },
      'content-title': {
        ...this.fields['content-title'],
        ...(this.sectionEditor.sectionExtract['content-title'] || {}),
      },
      'title-card': {
        ...this.fields['title-card'],
        ...(this.sectionEditor.sectionExtract['title-card'] || {}),
      },
      button: {
        ...this.fields.button,
        ...(this.sectionEditor.sectionExtract.button || {}),
      },
      reviews: this.sectionEditor.sectionExtract.reviews || this.fields.reviews,
    };

    if (!this.fields.reviews.length) {
      this.fields.reviews = [
        {
          image: '',
          stars: 5,
          content: '<h3>Review title</h3><p>Review text</p>',
          name: 'Customer',
        },
      ];
    }
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionSliderReviewKynorelle(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddReview() {
      this.fields.reviews.push({
        image: '',
        stars: 5,
        content: '<h3>Review title</h3><p>Review text</p>',
        name: 'Customer',
      });
    },
    handleRemoveReview(index) {
      if (this.fields.reviews.length <= 1) return;
      this.fields.reviews.splice(index, 1);
    },
    handleUploadImage(obj, index) {
      this.fields.reviews[index].image = obj.imageSrc;
    },
    handleRemoveUpload(index) {
      this.fields.reviews[index].image = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
